<script setup lang="ts">
import { isVotingPeriod } from '~/lib/vote';

definePageMeta({
  title: "模擬店大賞",
})
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px]">
    <Ribbon class="mt-6 mb-8 text-md md:text-2xl">
      模擬店大賞
    </Ribbon>

    <div class="grid grid-cols-1 gap-2 md:gap-4 mb-6">
      <div class="min-h-[96px] w-full">
        <ClientOnly>
          <div v-if="isVotingPeriod()">
            <NuxtLink class="btn btn-primary btn-outline rounded-none w-full h-full text-5xl shadow-md min-h-[96px]"
              to="/best-booth-award/form">
              投票はこちら！
            </NuxtLink>
          </div>
          <div v-else class="disabled [&>*]:btn-disabled tooltip tooltip-bottom w-full" data-tip="ただいま投票期間外">
            <NuxtLink class="btn btn-primary btn-outline rounded-none w-full h-full text-5xl shadow-md min-h-[96px]"
              to="/best-booth-award/form">
              投票はこちら！
            </NuxtLink>
          </div>
        </ClientOnly>
      </div>

      <NuxtLink class="btn text-lg h-14 btn-outline text-gray-700 hover:text-gray-700 hover:bg-stone-200"
        to="/best-booth-award/confirm">
        投票の確認はこちらから
      </NuxtLink>
    </div>
  </article>
</template>